(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[521],{

/***/ 6515:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(503);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var AssociatesCard = function(param) {
    var associate = param.associate;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "associates_grid ps-sm-4 pe-sm-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "coachDivImage",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: associate.image,
                    className: "w-100",
                    alt: "Coach"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fo-20 mfo-14 fw-700 bco mt-4 dyna text-center",
                children: associate.name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fo-13 mt-2 dyna text-center",
                children: associate.description
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AssociatesCard);


/***/ }),

/***/ 6471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _utils_urls__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1510);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _cards_AssociatesCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6383);
/* harmony import */ var _useWindowSize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3595);









var CoachesSection = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), associates = ref[0], setAssociates = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_useWindowSize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), 1), width = ref2[0];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var getAssociates = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var url, res, data2, i;
                return _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            url = _utils_urls__WEBPACK_IMPORTED_MODULE_3__/* ["default"].viewEmployeesApi.url */ .Z.viewEmployeesApi.url;
                            setLoading(true);
                            _ctx.next = 5;
                            return axios__WEBPACK_IMPORTED_MODULE_4___default().get(encodeURI(url));
                        case 5:
                            res = _ctx.sent;
                            data2 = [];
                            for(i = 0; i < res.data.length; i++){
                                if (res.data[i].role == "coach") {
                                    data2.push(res.data[i]);
                                }
                            }
                            setAssociates(data2);
                            setLoading(false);
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            setLoading(false);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function getAssociates() {
                return _ref.apply(this, arguments);
            };
        }();
        getAssociates();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "coachesHeading mb-5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "coachesHeading1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "bco fw-700 fo-50",
                            children: "MEET OUR COACHES"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "coachesHeading2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})
                    })
                ]
            }),
            !loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EmployeeGrid, {
                associates: associates,
                eachRow: width > 768 ? 4 : 2
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CoachesSection);
var EmployeeGrid = function(param) {
    var associates = param.associates, _eachRow = param.eachRow, eachRow = _eachRow === void 0 ? 4 : _eachRow;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), rows = ref[0], setRows = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var temp = [];
        var rowCount = Math.ceil(associates.length / eachRow);
        for(var i = 0; i < rowCount; i++){
            temp.push(associates.slice(eachRow * i, eachRow * i + eachRow));
        }
        setRows(temp);
    }, [
        eachRow,
        associates
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: rows.map(function(row, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EmployeeRow, {
                associates: row
            }, index);
        })
    });
};
var EmployeeRow = function(param) {
    var associates = param.associates;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "coachesSetion d-block",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "coachList",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "row bg-white m-0 mb-5 justify-content-center",
                children: associates.map(function(associate, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_cards_AssociatesCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        associate: associate
                    }, index);
                })
            })
        })
    });
};


/***/ }),

/***/ 3595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function useWindowSize() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([
        0,
        0
    ]), size = ref[0], setSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function() {
        var updateSize = function updateSize() {
            setSize([
                window.innerWidth,
                window.innerHeight
            ]);
        };
        window.addEventListener("resize", updateSize);
        updateSize();
        return function() {
            return window.removeEventListener("resize", updateSize);
        };
    }, []);
    return size;
}
/* harmony default export */ __webpack_exports__["Z"] = (useWindowSize);


/***/ }),

/***/ 503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ about; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./components/sections/CoachesSection.jsx
var CoachesSection = __webpack_require__(6471);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./components/cards/AssociatesCard.jsx
var AssociatesCard = __webpack_require__(6383);
// EXTERNAL MODULE: ./components/useWindowSize.jsx
var useWindowSize = __webpack_require__(3595);
;// CONCATENATED MODULE: ./components/sections/doctorsSection.jsx





var DoctorsSection = function(param) {
    var employees = param.employees;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useWindowSize/* default */.Z)(), 1), width = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-theme pt-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "coachesHeading mb-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "coachesHeading1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-white fw-700 fo-50",
                                children: "BOARD OF DOCTORS AND EXPERTS"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "coachesHeading2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeGrid, {
                    associates: employees,
                    eachRow: width > 768 ? 4 : 2
                })
            ]
        })
    });
};
/* harmony default export */ var doctorsSection = (DoctorsSection);
var EmployeeGrid = function(param) {
    var associates = param.associates, _eachRow = param.eachRow, eachRow = _eachRow === void 0 ? 4 : _eachRow;
    var ref = (0,react.useState)([]), rows = ref[0], setRows = ref[1];
    (0,react.useEffect)(function() {
        var temp = [];
        var rowCount = Math.ceil(associates.length / eachRow);
        for(var i = 0; i < rowCount; i++){
            temp.push(associates.slice(eachRow * i, eachRow * i + eachRow));
        }
        setRows(temp);
    }, [
        eachRow,
        associates
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: rows.map(function(row, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeRow, {
                associates: row
            }, index);
        })
    });
};
var EmployeeRow = function(param) {
    var associates = param.associates;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "coachesSetion d-block",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "coachList",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row bg-theme m-0 mb-5 justify-content-center",
                children: associates.map(function(associate, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AssociatesCard/* default */.Z, {
                        associate: associate
                    }, index);
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/sections/InternsSection.jsx





var InternsSection = function(param) {
    var employees = param.employees;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useWindowSize/* default */.Z)(), 1), width = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "coachesHeading mb-5 mt-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "coachesHeading1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bco fw-700 fo-50",
                            children: "MEET OUR ASSOCIATES"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "coachesHeading2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InternsSection_EmployeeGrid, {
                associates: employees,
                eachRow: width > 768 ? 4 : 2
            })
        ]
    });
};
/* harmony default export */ var sections_InternsSection = (InternsSection);
var InternsSection_EmployeeGrid = function(param) {
    var associates = param.associates, _eachRow = param.eachRow, eachRow = _eachRow === void 0 ? 4 : _eachRow;
    var ref = (0,react.useState)([]), rows = ref[0], setRows = ref[1];
    (0,react.useEffect)(function() {
        var temp = [];
        var rowCount = Math.ceil(associates.length / eachRow);
        for(var i = 0; i < rowCount; i++){
            temp.push(associates.slice(eachRow * i, eachRow * i + eachRow));
        }
        setRows(temp);
    }, [
        eachRow,
        associates
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: rows.map(function(row, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InternsSection_EmployeeRow, {
                associates: row
            }, index);
        })
    });
};
var InternsSection_EmployeeRow = function(param) {
    var associates = param.associates;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "coachesSetion d-block",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "coachList",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row bg-white m-0 mb-5 justify-content-center",
                children: associates.map(function(associate, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AssociatesCard/* default */.Z, {
                        associate: associate
                    }, index);
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/urls.js
var urls = __webpack_require__(1510);
;// CONCATENATED MODULE: ./pages/about.jsx











var About = function() {
    var ref = (0,react.useState)({
        doctor: [],
        intern: [],
        coach: []
    }), employees = ref[0], setEmployees = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    (0,react.useEffect)(function() {
        var getEmployees = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var url, res, temp;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            url = urls/* default.viewEmployeesApi.url */.Z.viewEmployeesApi.url;
                            setLoading(true);
                            _ctx.next = 5;
                            return axios_default().get(encodeURI(url));
                        case 5:
                            res = _ctx.sent;
                            temp = {
                                doctor: [],
                                intern: [],
                                coach: []
                            };
                            res.data.forEach(function(emp) {
                                temp[emp.role].push(emp);
                            });
                            setEmployees(temp);
                            setLoading(false);
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            setLoading(false);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function getEmployees() {
                return _ref.apply(this, arguments);
            };
        }();
        getEmployees();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://assets.alanvidyushbaptist.com/optimumwellness_logo.jpg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "About Optimum Wellness | World's Leading Fitness and Wellness Platform"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Optimum Wellness is the only community providing research-backed solutions to improve your overall fitness, nutrition, and wellness. We focus on intellectual wellness, social wellness, financial wellness, dietary wellness, physical wellness, emotional (psychological) wellness, occupational wellness, environmental wellness, spiritual wellness and sexual wellness."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ps-3 pe-3 ps-xl-5 pe-xl-5 mt-4 mt-xl-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row m-0 ps-lg-5 pe-lg-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-sm-7 m-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/about.png",
                                    className: "w-100",
                                    alt: "image"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-sm-5 m-auto",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "fo-70 bco fw-700 mfo-28 lg-48 ms-lg-5 d-none d-sm-block",
                                        children: [
                                            "About ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "Optimum ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "Wellness"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "fo-26 bco fw-700 text-center mt-4 d-sm-none",
                                        children: "About Optimum Wellness"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ps-lg-5 pe-lg-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ps-lg-5 pe-lg-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ps-lg-5 pe-lg-5 mt-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ps-3 pe-3 ps-sm-5 pe-sm-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "fo-36 fw-700 bco text-center mfo-24",
                                            children: "OUR STORY"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "fo-14 mt-4 justify",
                                            children: [
                                                "Optimum Wellness is the world’s leading and only platform that’s been established to provide research-backed diversified solutions to holistically elevate an individual’s status of wellness. An individual’s wellness is influenced by an increasingly broad scope of factors that most lifestyle coaches have an inadequate understanding of and as a consequence of which most people find themselves struggling to find fulfillment in their life. ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "Optimum Wellness provides integrated lifestyle advice considering all influential factors of a person’s wellness, such as their intellectual wellness, social wellness, financial wellness, dietary wellness, physical wellness, emotional(psychological) wellness, occupational wellness, environmental wellness, spiritual wellness and sexual wellness. ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "We are currently majorly prioritizing the physical and dietary aspects of wellness and shall soon be rolling out programmes to optimize other aspects of wellness. Our mission is to optimize the wellness of the entire world at large!"
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "aboutContainer d-none d-md-block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row m-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-md-6 text-center p-md-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "aboutContainerImg w-50",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/assets/about1.png",
                                        className: "w-100",
                                        alt: "image"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fo-26 text-white fw-700 mt-4",
                                    children: "ALAN BAPTIST"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fo-24 text-white fw-700 mt-1",
                                    children: "CEO & FOUNDER"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fo-14 text-white mt-4 justify",
                                    children: [
                                        "India’s First Optimum Wellness Coach, Alan Baptist is a young entrepreneur with a powerful vision of empowering individuals by positively transforming various aspects of their lifestyles ranging from optimum physical and dietary wellness to psychological, financial, social, spiritual and other critical and popular facets of wellness.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Owing to Alan’s wealth of experience owing to his exposure in various fields across and the Optimum Wellness brand was founded to offer phenomenal fine-tuned counseling with respect to various aspects of an individual’s life.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "He is a Nutrition certified nutritionist (Canada), and has also completed studying MAC-nutrition evidence-based course (UK) and the International Sports and Science Association (ISSA) certified trainer course,  after which he started scientifically educating people about fitness and nutrition and has successfully impacted on and transformed the lives of over 20000+ people effectively.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "He is on a mission to educate as many people as possible with evidence-based knowledge in nutrition and fitness sciences. "
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-md-6 text-center p-md-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "aboutContainerImg w-50",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/assets/about2.png",
                                        className: "w-100",
                                        alt: "image"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fo-26 text-white fw-700 mt-4",
                                    children: "VINIT BAPTIST"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fo-24 text-white fw-700 mt-1",
                                    children: "CEO & FOUNDER"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fo-14 text-white mt-4 justify",
                                    children: [
                                        "India’s First MNU Certified Nutrition Fitness Coach, Vinit Baptist is the President and Founder of Optimum Wellness and he is well-versed with topics related to fitness and nutrition. He is always learning, teaching and coaching people the latest that has been proven in the field of fitness and nutrition.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "He has educated numerous people about fitness and nutrition and that number is growing every day. You will find him talking to people about exercises, mobility, nutrition, weight training and strength and conditioning among other topics.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "He has successfully set up four gyms across Kolkata under the brand name ZEST FITNESS STUDIO and plans to expand further globally. He is considered to be an authority and icon by various fitness professionals and he has conducted various successful workshops on nutrition, client assessment and exercise fundamentals.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "He is on a quest to educate as many people as possible with evidence-based knowledge in nutrition and fitness sciences. "
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "aboutContainer d-md-none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-center p-sm-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/assets/about1.png",
                            className: "w-50",
                            alt: "image"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fo-26 text-white fw-700 mt-4",
                            children: "ALAN BAPTIST"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fo-24 text-white fw-700 mt-1",
                            children: "CEO & FOUNDER"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fo-14 text-white mt-4 justify",
                            children: [
                                "India’s First Optimum Wellness Coach, Alan Baptist is a young entrepreneur with a powerful vision of empowering individuals by positively transforming various aspects of their lifestyles ranging from optimum physical and dietary wellness to psychological, financial, social, spiritual and other critical and popular facets of wellness.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Owing to Alan’s wealth of experience owing to his exposure in various fields across and the Optimum Wellness brand was founded to offer phenomenal fine-tuned counseling with respect to various aspects of an individual’s life.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "He is a Nutrition certified nutritionist (Canada), and has also completed studying MAC-nutrition evidence-based course (UK) and the International Sports and Science Association (ISSA) certified trainer course,  after which he started scientifically educating people about fitness and nutrition and has successfully impacted on and transformed the lives of over 20000+ people effectively.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "He is on a mission to educate as many people as possible with evidence-based knowledge in nutrition and fitness sciences. "
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "aboutContainer d-md-none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-center p-sm-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/assets/about2.png",
                            className: "w-50",
                            alt: "image"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fo-26 text-white fw-700 mt-4",
                            children: "VINIT BAPTIST"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fo-24 text-white fw-700 mt-1",
                            children: "CEO & FOUNDER"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fo-14 text-white mt-4 justify",
                            children: [
                                "India’s First MNU Certified Nutrition Fitness Coach, Vinit Baptist is the President and Founder of Optimum Wellness and he is well-versed with topics related to fitness and nutrition. He is always learning, teaching and coaching people the latest that has been proven in the field of fitness and nutrition.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "He has educated numerous people about fitness and nutrition and that number is growing every day. You will find him talking to people about exercises, mobility, nutrition, weight training and strength and conditioning among other topics.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "He has successfully set up four gyms across Kolkata under the brand name ZEST FITNESS STUDIO and plans to expand further globally. He is considered to be an authority and icon by various fitness professionals and he has conducted various successful workshops on nutrition, client assessment and exercise fundamentals.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "He is on a quest to educate as many people as possible with evidence-based knowledge in nutrition and fitness sciences. "
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-5 pt-lg-5"
            }),
            !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoachesSection/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(doctorsSection, {
                        employees: employees.doctor,
                        loading: loading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_InternsSection, {
                        employees: employees.intern,
                        loading: loading
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "aboutBottomContainer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row m-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-2 col-sm-3"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-10 col-sm-9 text-center ms-auto me-auto mb-auto mt-sm-auto mt-15",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fo-50 bco fw-700 lg-40 mfo-18 mt-xl-5",
                                    children: [
                                        "Ready To Take Care of ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Your Wellness ?"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/contact",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "btn sendButton pulsating",
                                        children: "Contact us"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var about = (About);


/***/ }),

/***/ 1510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ baseUrl; }
/* harmony export */ });
var baseUrl = "https://itchy-blue-seagull.cyclic.app";
// export const domainUrl = "https://optimumwellness.in";
// export const baseUrl = `http://localhost:8081`;
// http://localhost:8081
var urlSet = {
    // Blogs
    get_blogApi: {
        // Get blogs
        url: baseUrl + "/api/v1/blogs",
        method: "GET"
    },
    post_blogApi: {
        // Add a new blog
        url: baseUrl + "/api/v1/blogs/",
        method: "POST"
    },
    edit_blogApi: {
        // Edit blog
        url: baseUrl + "/api/v1/blogs/",
        method: "PATCH"
    },
    delete_blogApi: {
        // Delete a blog
        url: baseUrl + "/api/v1/blogs/",
        method: "DELETE"
    },
    get_AuthorblogApi: {
        // Get blogs of an author
        url: baseUrl + "/api/v1/blogs/author/",
        method: "GET"
    },
    get_featuredblogApi: {
        // Get featured blogs
        url: baseUrl + "/api/v1/blogs/featured",
        method: "GET"
    },
    data_intervalApi: {
        // set data interval
        url: baseUrl + "/api/v1/blogs/updateDataInterval",
        method: "PATCH"
    },
    // Admin
    adminLoginApi: {
        // Admin login
        url: baseUrl + "/api/v1/auth/api/v1/auth/login",
        method: "POST"
    },
    adminUpdateApi: {
        // Admin login
        url: baseUrl + "/api/v1/auth/api/v1/auth/update",
        method: "PATCH"
    },
    // Admin blogs
    add_blog_to_featuredApi: {
        // Add to featured blogs
        url: baseUrl + "/api/v1/admin/featuredBlog/",
        method: "PATCH"
    },
    delete_blog_from_featuredApi: {
        // Delete from featured blogs
        url: baseUrl + "/api/v1/admin/featuredBlog/",
        method: "DELETE"
    },
    // Admin services
    viewServicesApi: {
        // To get services
        url: baseUrl + "/api/v1/admin/service/",
        method: "GET"
    },
    getMainServiceApi: {
        // To get services based on level
        url: baseUrl + "/api/v1/admin/service",
        method: "GET"
    },
    addServiceApi: {
        // To add new service
        url: baseUrl + "/api/v1/admin/service",
        method: "POST"
    },
    deleteServiceApi: {
        // To delete services
        url: baseUrl + "/api/v1/admin/service/",
        method: "DELETE"
    },
    editServicesApi: {
        // Update service names
        url: baseUrl + "/api/v1/admin/service/",
        method: "PATCH"
    },
    // Admin offers
    editOffersApi: {
        // Update offer
        url: baseUrl + "/api/v1/admin/offer/",
        method: "PATCH"
    },
    deleteOffersApi: {
        // Delete offer
        url: baseUrl + "/api/v1/admin/offer/",
        method: "DELETE"
    },
    // Admin coupons
    viewCouponsApi: {
        // Get all coupons
        url: baseUrl + "/api/v1/admin/coupon",
        method: "GET"
    },
    addCouponsApi: {
        // Add new coupon
        url: baseUrl + "/api/v1/admin/coupon/",
        method: "POST"
    },
    deleteCouponsApi: {
        // Delete a coupon
        url: baseUrl + "/api/v1/admin/coupon/",
        method: "DELETE"
    },
    // Payments
    applyCouponApi: {
        // Apply coupon
        url: baseUrl + "/api/v1/payment/applyCoupon",
        method: "POST"
    },
    paymentApi: {
        // Create payment order id
        url: baseUrl + "/api/v1/payment/generateReceipt",
        method: "POST"
    },
    verifyPaymentApi: {
        // Verify payments status after razorpay
        url: baseUrl + "/api/v1/payment/verifyPayment",
        method: "POST"
    },
    // Admin transactions
    viewTransactionsApi: {
        // View all transactions
        url: baseUrl + "/api/v1/transaction",
        method: "GET"
    },
    addTransactionsApi: {
        // Add transactions
        url: baseUrl + "/api/v1/transaction/",
        method: "POST"
    },
    updateTransactionsApi: {
        // Update transactions
        url: baseUrl + "/api/v1/transaction/",
        method: "PATCH"
    },
    deleteTransactionsApi: {
        // Delete transactions
        url: baseUrl + "/api/v1/transaction/",
        method: "DELETE"
    },
    // Add employees
    viewEmployeesApi: {
        // Get all employees
        url: baseUrl + "/api/v1/employees/?index=0&limit=50",
        method: "GET"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (urlSet);


/***/ }),

/***/ 943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 3375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 1566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [217,774,888,179], function() { return __webpack_exec__(6515); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);